import {
  safeLocalStorageGetItem,
  safeLocalStorageSetItem,
} from "@/util/safeLocalStorage";
import { makeAutoObservable } from "mobx";

export type ThemeMode = "light" | "dark" | "auto";

class ThemeStore {
  // 用户选择的主题模式
  mode: ThemeMode = "dark";

  systemTheme: "light" | "dark" = "dark";

  // 实际应用的主题 (考虑系统偏好)
  get resolvedTheme(): "light" | "dark" {
    if (this.mode === "auto") {
      return this.systemTheme;
    }
    return this.mode;
  }

  constructor() {
    makeAutoObservable(this);
  }

  init() {
    // 仅在客户端执行
    if (typeof window === "undefined") return;

    // 从 localStorage 读取用户偏好
    const savedMode = safeLocalStorageGetItem("theme-mode") as ThemeMode;
    if (
      savedMode &&
      (savedMode === "light" || savedMode === "dark" || savedMode === "auto")
    ) {
      this.mode = savedMode;
    }

    // 监听系统主题变化
    // this.detectSystemTheme();
    // this.watchSystemTheme();

    // 应用主题
    this.applyTheme();
  }

  private detectSystemTheme() {
    if (typeof window === "undefined") return;

    const isDark = window.matchMedia("(prefers-color-scheme: dark)").matches;
    this.systemTheme = isDark ? "dark" : "light";
  }

  private watchSystemTheme() {
    if (typeof window === "undefined") return;

    window
      .matchMedia("(prefers-color-scheme: dark)")
      .addEventListener("change", (e) => {
        this.systemTheme = e.matches ? "dark" : "light";
        if (this.mode === "auto") {
          this.applyTheme();
        }
      });
  }

  // 使用箭头函数确保 this 绑定
  setMode = (mode: ThemeMode) => {
    this.mode = mode;
    if (typeof window !== "undefined") {
      safeLocalStorageSetItem("theme-mode", mode);
    }
    this.applyTheme();
  };

  private applyTheme() {
    if (typeof window === "undefined") return;

    const theme = this.resolvedTheme;
    document.documentElement.setAttribute("data-theme", theme);
  }

  // 使用箭头函数确保 this 绑定
  toggleTheme = () => {
    const currentTheme = this.resolvedTheme;
    const nextMode = currentTheme === "light" ? "dark" : "light";

    this.setMode(nextMode);
  };
}

export const themeStore = new ThemeStore();
